"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleEventsExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const utils_1 = require("../../../utils");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const bookings_1 = require("../../../store/bookings");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const DateTransformer_1 = tslib_1.__importStar(require("./DateTransformer"));
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getScheduleEvents = toolkitRaw.createAsyncThunk('schedule/fetch_events', async ({ start_at, end_at, limit, groupBy = 'minutes' }, { rejectWithValue, dispatch, getState }) => {
    try {
        const state = getState();
        if ((0, lodash_get_1.default)(state, 'bookings.booking.data.internal_id', '')) {
            dispatch((0, bookings_1.clearBooking)());
        }
        const params = {
            includes: (0, getIncludesParams_1.getDefaultIncludesParams)('saas_bookings'),
        };
        if (start_at) {
            params['from'] = start_at;
        }
        if (end_at) {
            params['to'] = end_at;
        }
        if (limit) {
            params['limit'] = limit;
        }
        const response = await services_1.default.get('/api/saas/me/bookings', {
            params,
        });
        response.data.included.forEach((includedData) => {
            var _a, _b, _c;
            if (includedData.type === 'item') {
                includedData.meta = {
                    ...includedData.meta,
                    category_id: Number(((_c = (_b = (_a = includedData.relationships) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id) || 0),
                };
            }
        });
        const payload = (0, utils_1.deserialize)(response.data);
        if (groupBy === 'day') {
            const transform = new DateTransformer_1.default(payload.data, DateTransformer_1.GroupBy.day);
            return { data: payload.data, group: transform.all() };
        }
        if (groupBy === 'hour') {
            const transform = new DateTransformer_1.default(payload.data, DateTransformer_1.GroupBy.hour);
            return { data: payload.data, group: transform.all() };
        }
        const transform = new DateTransformer_1.default(payload.data, DateTransformer_1.GroupBy.minutes);
        return { data: payload.data, group: transform.all() };
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getScheduleEventsExtraReducers = (builder) => {
    builder.addCase(getScheduleEvents.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getScheduleEvents.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.group = action.payload.group;
        state.loading = false;
        state.error = false;
    });
    builder.addCase(getScheduleEvents.rejected, (state) => {
        state.loading = false;
        state.error = true;
    });
};
exports.getScheduleEventsExtraReducers = getScheduleEventsExtraReducers;
exports.default = getScheduleEvents;
//# sourceMappingURL=index.js.map